import moment from "moment";
import React, { useEffect, useState } from "react";
import close from "../../../assets/images/close.svg";
import { Col, Form, Nav, Row, Tab } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { ProjectTermGetList } from "../../../services/ReduxTookit/Slice/ProjectTermRedux";
import { useDispatch } from "react-redux";
import Loader, { LoaderType } from "../../../component/common-component/Loader";
import downarrow from "../../../assets/images/downarrow.svg";
import uparrow from "../../../assets/images/uparrow.svg";
import { useParams } from "react-router-dom";

const CaseFilterPopup = ({
  sortStatePayload,
  setSortStatePayload,
  filters,
  setFilters,
  handleshowPopup,
  showStatusFilter,
}) => {
  const dispatch = useDispatch();
  let initJson = {
    Sort: {
      field: sortStatePayload.field ? sortStatePayload.field : null,
      direction: sortStatePayload.direction ? sortStatePayload.direction : null,
    },
    Filter: {
      status: filters?.status ? filters?.status : "",
      priority: filters?.priority ? filters?.priority : "",
      caseType: filters?.caseType ? filters?.caseType : "",
    },
  };
  const [filterSort, setfilterSort] = useState(initJson);
  const [sortState, setSortState] = React.useState({
    field: sortStatePayload.field ? sortStatePayload.field : null,
    direction: sortStatePayload.direction ? sortStatePayload.direction : null,
  });

  const [ProjectTermList, setProjectTermList] = useState({
    Status: [],
    Priority: [],
    CaseType: [],
  });

  const handleReset = () => {
    setSortStatePayload({ field: null, direction: null });
    setSortState({
      field: null,
      direction: null,
    });
    setfilterSort({
      Sort: {
        field: null,
        direction: null,
      },
      Filter: {
        status: "",
        priority: "",
        caseType: "",
      },
    });
    setFilters({
      status: "",
      priority: "",
      caseType: "",
    });
  };

  const handleApply = (e) => {
    setSortStatePayload(sortState);
    setSortState(filterSort.Sort);
    setFilters(filterSort.Filter);
    handleshowPopup(e);
  };

  async function getProjectTermList() {
    dispatch(ProjectTermGetList({}))?.then((response) => {
      if (response?.payload?.isValidate) {
        if (response?.payload?.data?.data?.length > 0) {
          setProjectTermList({
            CaseType: response?.payload?.data?.data.filter(
              (f) => f.category === "Case Type Term"
            ),
            Priority: response?.payload?.data?.data.filter(
              (f) => f.category === "Priority Term"
            ),
            Status: response?.payload?.data?.data.filter(
              (f) => f.category === "Case Status Term"
            ),
          });
        }
      }
      if (!response?.payload?.isValidate) {
      }
    });
  }

  useEffect(() => {
    getProjectTermList();
  }, []);

  return (
    <>
      <Tab.Container
        id="left-tabs-example"
        defaultActiveKey="first"
        className="underlined-tabing"
      >
        <div className="schedular-popup sort-and-filter-popup">
          <div className="popup-title d-block p-0">
            <Nav variant="pills" className="flex">
              <Nav.Item>
                <Nav.Link eventKey="first">Filter</Nav.Link>
              </Nav.Item>
              <Nav.Item className="position-relative">
                <Nav.Link eventKey="second">Sort</Nav.Link>
                <img
                  src={close}
                  alt="close"
                  id="sort-filter"
                  className="cursor-pointer"
                  onClick={(e) => {
                    handleshowPopup(e);
                  }}
                />
              </Nav.Item>
            </Nav>
          </div>
          <div className="popup-body">
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <div className="logfilterpopup">
                  <Row>
                    {showStatusFilter && (
                      <div className="single-filter">
                        <div className="d-flex align-items-center justify-content-between common-tab-titles">
                          <h5 className="">Status</h5>
                        </div>
                        <div className="all-grey-blue-badges">
                          {ProjectTermList.Status.length !== 0 ? (
                            ProjectTermList.Status.map((itm, idx) => (
                              <span
                                key={idx}
                                className={
                                  filterSort?.Filter?.status === itm?.term
                                    ? "grey-badge active"
                                    : "grey-badge"
                                }
                                onClick={() => {
                                  setfilterSort({
                                    ...filterSort,
                                    Filter: {
                                      ...filterSort.Filter,
                                      status: itm?.term,
                                    },
                                  });
                                }}
                              >
                                {itm?.term}
                              </span>
                            ))
                          ) : (
                            <div>
                              <Loader
                                type={LoaderType.SupportFilters}
                                count={3}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    <div className="single-filter">
                      <div className="d-flex align-items-center justify-content-between common-tab-titles">
                        <h5 className="">Priority</h5>
                      </div>
                      <div className="all-grey-blue-badges">
                        {ProjectTermList.Priority.length !== 0 ? (
                          ProjectTermList.Priority.map((itm, idx) => (
                            <span
                              key={idx}
                              className={
                                filterSort?.Filter?.priority === itm?.term
                                  ? "grey-badge active"
                                  : "grey-badge"
                              }
                              // onClick={() => FnForSetStatus(status)}
                              onClick={() => {
                                setfilterSort({
                                  ...filterSort,
                                  Filter: {
                                    ...filterSort.Filter,
                                    priority: itm?.term,
                                  },
                                });
                              }}
                            >
                              {itm?.term}
                            </span>
                          ))
                        ) : (
                          <div>
                            <Loader
                              type={LoaderType.SupportFilters}
                              count={3}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="single-filter">
                      <div className="d-flex align-items-center justify-content-between common-tab-titles">
                        <h5 className="">Case Type</h5>
                      </div>
                      <div className="all-grey-blue-badges">
                        {ProjectTermList.CaseType.length !== 0 ? (
                          ProjectTermList.CaseType.map((itm, idx) => (
                            <span
                              key={idx}
                              className={
                                filterSort?.Filter?.caseType === itm?.term
                                  ? "grey-badge active"
                                  : "grey-badge"
                              }
                              onClick={() => {
                                setfilterSort({
                                  ...filterSort,
                                  Filter: {
                                    ...filterSort.Filter,
                                    caseType: itm?.term,
                                  },
                                });
                              }}
                            >
                              {itm?.term}
                            </span>
                          ))
                        ) : (
                          <div>
                            <Loader
                              type={LoaderType.SupportFilters}
                              count={3}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <Col xl={12}>
                      {/* <Form.Label className="common-label">Select Date</Form.Label> */}
                      <div></div>
                    </Col>
                  </Row>
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="second">
                <div className="logfilterpopup">                  
                    <Row>
                      {["Date", "Priority", "Status", "CaseType"].map(
                        (field) => (
                          <div key={field} className="single-filter">
                            <div className="d-flex align-items-center justify-content-between common-tab-titles">
                              <h5 className="">
                                {/* {field.charAt(0).toUpperCase() + field.slice(1)} */}
                                {field}
                              </h5>
                              <div className="d-flex gap-2 all-grey-blue-badges">
                                <p
                                  className={
                                    sortState.field === field &&
                                    sortState.direction === "ASC"
                                      ? "grey-badge filter-up-down-icon active"
                                      : "grey-badge filter-up-down-icon"
                                  }
                                  onClick={() => {
                                    setSortState({ field, direction: "ASC" });
                                  }}
                                >
                                  <img src={uparrow} alt="uparrow" />
                                </p>
                                <p
                                  className={
                                    sortState.field === field &&
                                    sortState.direction === "DESC"
                                      ? "grey-badge filter-up-down-icon active"
                                      : "grey-badge filter-up-down-icon"
                                  }
                                  onClick={() => {
                                    setSortState({ field, direction: "DESC" });
                                  }}
                                >
                                  <img src={downarrow} alt="downarrow" />
                                </p>
                              </div>
                            </div>
                          </div>
                        )
                      )}
                    </Row>                  
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
          <div className="popup-footer">
            <button className="grey-btn" onClick={() => handleReset()}>
              Reset
            </button>
            <button
              className="blue-btn"
              onClick={async (e) => {
                handleApply(e);
              }}
            >
              Apply
            </button>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};

export default CaseFilterPopup;
